<template>
    <li
        v-tooltip="{
            content: item.tooltipText,
            delay: { show: 500, hide: 100 },
        }"
        :class="[{ current: item.isCurrent, disabled: item.isDisabled }]"
        @click="selectItem(item, checkbox)"
    >
        <span
            v-if="item.iconOptions"
            :style="`color: ${item.iconOptions.iconColor}`"
        >
            <font-awesome-icon
                :icon="`${item.iconOptions.iconStyle} ${item.iconOptions.iconName}`"
                :class="`icon mr-3 ${item.iconOptions.iconColor}--text`"
            />
        </span>
        <div class="checkbox-holder">
            <AonCheckbox
                v-if="checkbox"
                :isChecked="item.checked"
                remove-margins
                class="mr-3"
            />
        </div>
        <font-awesome-icon
            v-if="item.arrowSide === 'left'"
            icon="fas fa-angle-left"
            :class="`icon ${darkMode ? 'grey06' : itemColor}--text`"
        />
        <div class="full-width">
            <p :class="[`${darkMode ? 'grey06' : itemColor}--text`]">
                {{ item.itemText }}
            </p>
            <p
                v-if="item.itemDesc"
                :class="[
                    `${darkMode ? 'grey06' : itemColor}--text`,
                    'small',
                    'description',
                ]"
                v-html="item.itemDesc"
            ></p>
        </div>
        <font-awesome-icon
            v-if="item.arrowSide === 'right'"
            icon="fas fa-angle-right"
            :class="`icon ${darkMode ? 'grey06' : itemColor}--text`"
        />
        <div
            v-if="isClusterDropdown && item.isRecommended"
            class="recommended-chip py-2 px-3"
        >
            <font-awesome-icon
                icon="far fa-chart-network"
                class="icon white--text"
            />
            <p class="white--text pl-2 extra-small">Recommended</p>
        </div>
        <div
            :class="[
                { 'sub-open': item.showSubItems },
                'items sub-items',
                item.arrowSide,
            ]"
            :style="`width: ${itemWidth}; transform: translate(${
                item.arrowSide === 'left' ? '-' + itemWidth : itemWidth
            }, ${index * 45}px)`"
        >
            <ul>
                <template
                    v-for="(subItem, subIndex) in item.items"
                    :key="`s_${subIndex}`"
                >
                    <AonDropdownItem
                        :item="subItem"
                        :index="subIndex + index - 1"
                        :checkbox="item.checkbox"
                        :darkMode="darkMode"
                        :itemColor="itemColor"
                        :itemWidth="itemWidth"
                        @selected="selectItem"
                    />
                </template>
            </ul>
        </div>
    </li>
</template>

<script setup>
import AonCheckbox from './AonCheckbox.vue';

import { onMounted, computed, defineExpose, ref } from 'vue';

const props = defineProps({
    item: {
        type: Object,
        default: () => {
            return null;
        },
    },
    index: {
        type: Number,
        required: true,
    },
    checkbox: {
        type: Boolean,
        default: false,
    },
    itemColor: {
        type: String,
        default: 'grey01',
    },
    darkMode: {
        type: Boolean,
        default: false,
    },
    itemWidth: {
        type: String,
        default: '100%',
    },
    isClusterDropdown: {
        type: Boolean,
        default: false,
    },
});
const emit = defineEmits(['selected']);

const selected = ref({});
const searchInput = ref();
const finalItems = ref(props.items);
const selectedItems = ref(props.items);

const selectItem = (item) => {
    emit('selected', item);
};
</script>

<script>
export default {
    name: 'AonDropdownItem',
};
</script>
